/**
* @ngdoc component
* @name help.component:itxHelpMenu
* @description
* Main menu component.
*/
(function() {
    'use strict';

    
    var itxHelpMenu = {
        bindings:{
            menu:'<'
        },
        controller:   itxHelpMenuCtrl,
        templateUrl: 'help-menu.component.html'
    };
    angular.module('itxApp.help').component('itxHelpMenu',itxHelpMenu);

    
    itxHelpMenuCtrl.$inject = [
        'ItxStaticResourceSvc',
        'helpService',
        'DUTTI_CONS'
    ];

    function itxHelpMenuCtrl (
        ItxStaticResourceSvc,
        helpService,
        DUTTI_CONS
    ) {
        var _this = this;

        _this.$onInit = function () {
            _this.title = _this.menu.title.blocks[0].text;
            _this.filterContent(DUTTI_CONS.i_stores[inditex.iStoreId]);

            _this.removeDuplicate();
        };

        _this.getIcon = function(iconName){
            return ItxStaticResourceSvc.getIcon(helpService.getIconPath(iconName));
        };

        _this.deleteItemByName = function (key) {
            _this.menu.items = _this.menu.items.filter(function(item) {
                return item.name !== key;
            });
        }

        _this.filterContent = function(storeCountry) {
            if(storeCountry !== 'DuttiES') {
                _this.deleteItemByName('wallet');
            }
            switch(storeCountry) {
                case 'DuttiBG': 
                case 'DuttiCN':
                case 'DuttiKR': 
                case 'DuttiHR': 
                case 'DuttiDK': 
                case 'DuttiSI':
                case 'DuttiSK':
                case 'DuttiFI': 
                case 'DuttiNL':
                case 'DuttiHU': 
                case 'DuttiHU':
                case 'DuttiCZ':
                case 'DuttiRO': 
                case 'DuttiRU': 
                case 'DuttiFR': {
                    _this.deleteItemByName('gift');
                    break;
                }
                case 'DuttiEE':
                case 'DuttiLV': 
                case 'DuttiLT':
                case 'DuttiTR': 
                case 'DuttiMX': 
                case 'DuttiPT': 
                case 'DuttiMC': {
                    _this.deleteItemByName('gift');
                    _this.deleteItemByName('wallet');
                    break;
                }
                case 'DuttiIT':
                case 'DuttiGR': {
                    _this.deleteItemByName('wallet');
                    break;
                }
            }
        }

        _this.removeDuplicate = function() {
            var uniq = {}
            this.menu.items =  _this.menu.items.filter(function(obj) {
                return !uniq[obj.id] && (uniq[obj.id] = true);
            });
        }


    }

   
})();